module.exports = __webpack_public_path__ + "img/20190723150006435.6d418fa2.png";